<template>
    <a v-if="url"
       :class="btnClass"
       :href="urlGenerator(url)"
       v-on="$listeners"
       v-bind="$attrs"
    >
        {{ title }}
    </a>

    <button v-else
            :class="btnClass"
            v-on="$listeners"
            v-bind="$attrs"
    >
        {{ title }}
    </button>
</template>

<script>
import {urlGenerator} from "../../../Helpers/AxiosHelper";

export default {
    name: "AddNewButton",
    props: {
        title: {},
        url: {
            default: false
        },
        icon: {
            default: false
        },
        btnClass: {
            default: 'btn btn-primary'
        },
    },
    data() {
        return {
            urlGenerator
        }
    }
}
</script>

<style scoped>

</style>
